/* eslint-disable @typescript-eslint/naming-convention */
// Variable name is not camelCase, but the underscore is used to properly parse the property name in a readable format in HTML.

import { FormPurchaseOrderLinesSettings } from './form-purchase-order-lines-settings';

// To keep consistency with the other models. This one has the short / long type as well but is not used.
export class FormPickUpSettings {
  type = 'short' as const;
  short = new FormPickUpSettingsShort();
  singleStyle = true;
  constructor(type: 'short') {
    this.type = type;
  }
}

export class FormPickUpSettingsShort {
  purchase_Order_Lines: FormPurchaseOrderLinesSettings = {
    enabled: true,
    received: true,
    toReceive: true,
    type: true,
    unit_of_Measure_Code: true,
    purchasedPrice: true,
    work_Order: true,
    work_Order_Line: true,
    job_No: false,
    job_Description: false,
    job_Task_No: false,
    job_Task_Description: false,
    job_Line_Type: false,
  };

  payment = {
    comment: true,
    enabled: true,
    location: true,
    order_Date: true,
  };
}
